import { render } from "./DurationData.vue?vue&type=template&id=06a18b81&scoped=true"
import script from "./DurationData.vue?vue&type=script&lang=js"
export * from "./DurationData.vue?vue&type=script&lang=js"

import "./DurationData.vue?vue&type=style&index=0&id=06a18b81&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06a18b81"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';import TouchHold from 'quasar/src/directives/TouchHold.js';
import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QBadge,QChip,QMenu,QList,QItem,QItemSection});qInstall(script, 'directives', {TouchHold,Ripple});
